import React, { useState, useEffect } from 'react'

import NavItem from '../NavItem'

import { IconContext } from 'react-icons'
import { MdChangeHistory } from 'react-icons/md'

//lodash library to throttle the scroll events
var _ = require('lodash');

function Navbar({ handler }) {

    // for dynamic design change of the navbar depending on scrolling
    const primaryNavbarStyle = { background: "none", backgroundColor: "transparent" }
    const secondaryNavbarStyle = { backgroundColor: "rgba(30,30,30,1.0)" }
    const [navbarDesign, setNavbarDesign] = useState(primaryNavbarStyle)

    const handleScroll = () => {

        if (window.scrollY > 100) {
            if (navbarDesign !== secondaryNavbarStyle) {
                setNavbarDesign(secondaryNavbarStyle)
            }
        }
        else {
            setNavbarDesign(primaryNavbarStyle)
        }
    }

    useEffect(() => {
        window.addEventListener("scroll", _.throttle(handleScroll, 300, { "leading": false, "trailing": true }))
    }, [])

    // nav-burger
    const [burgerActive, setBurgerActive] = useState(false)

    return (
        <nav
            className="navbar is-fixed-top is-active has-shadows is-transparent"
            role="navigation"
            aria-label="main navigation"
            style={navbarDesign}
        >
            <div className="navbar-brand">

                <a className="navbar-item" href="/">
                    <IconContext.Provider value={{ color: 'white', size: '32px' }}>
                        <MdChangeHistory />
                    </IconContext.Provider>
                </a>

                <span role="button"
                    className={`navbar-burger burger ${burgerActive ? 'is-active' : ''}`}
                    aria-label="menu"
                    aria-expanded="false"
                    data-target="navMenu"
                    style={{ color: "white" }}
                    onClick={() => {
                        setBurgerActive(!burgerActive) //toggle nav-burger activation state
                    }}
                >
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </span>
            </div>

            <div    id="navMenu" 
                    className={`navbar-menu ${burgerActive ? 'is-active' : ''}`}
                    style={{ backgroundColor: "transparent" }}
            >
                <div className="navbar-start">
                </div>
                <div className="navbar-end">
                    <span className='navbar-item'>
                        <NavItem name={"Services"} handler={handler} index={1} />
                    </span>
                    <span className='navbar-item'>
                        <NavItem name={"Portfolio"} handler={handler} index={2} />
                    </span>
                    <span href='#' className='navbar-item'>
                        <NavItem name={"Contact Us"} handler={handler} index={3} />
                    </span>
                </div>
            </div>
        </nav>
    )
}

export default Navbar
